import {Option} from 'nc-shared';
import {Observable, of} from 'rxjs';

/**
 * Class which holds common enumeration operations.
 */
export class EnumUtils {
  /**
   * Converts enumeration into array of @EnumItem.
   * @param enumeration Enumeration to be converted to array
   */
  static toItems(enumeration): Option[] {
    return Object.entries(enumeration).map(([key, value]) => ({value: key, text: value as string}));
  }

  /**
   * Converts enumeration into observable array of @EnumItem.
   * @param enumeration Enumeration to be converted to array
   */
  static toObservableItems(enumeration): Observable<Option[]> {
    return of(this.toItems(enumeration));
  }
}
